import Client from '@/components/Client/Client.vue';
import ProjectCreate from '@/components/Project/Create/ProjectCreate.vue';

export default [
    {
        name: 'client',
        path: '/client/:client_id?',
        component: Client,
        meta: { roles: ['role_administrator'], menuSection: 'admin' },
    },
    {
        name: 'client-projects',
        path: '/client/projects/:client_id',
        component: Client,
        meta: { roles: ['role_administrator'], menuSection: 'admin' },
    },
];
